<section class="market-share-progress">
  <h3 class="market-share-progress__title">{{ title }}</h3>

  <div class="market-share-progress__track" *ngIf="showPrimaryBar">
    <ng-container *ngIf="showSegments">
      <span
        *ngFor="let segment of segments"
        class="market-share-progress__segment"
        [ngStyle]="{ left: segment.left + '%', width: segment.width + '%', background: segment.color }"
      ></span>
    </ng-container>
    <span class="market-share-progress__fill" [ngStyle]="fillStyle"></span>
    <span class="market-share-progress__marker" [ngStyle]="markerStyle"></span>
    <span
      class="market-share-progress__marker-value"
      *ngIf="showMarkerValueLabel"
    >
      {{ valueLabel }}
    </span>
  </div>

  <div class="market-share-progress__edge-labels" *ngIf="showEdgeLabels">
    <span class="market-share-progress__edge-label market-share-progress__edge-label--start" *ngIf="startLabel">
      {{ startLabel }}
    </span>
    <span class="market-share-progress__edge-label market-share-progress__edge-label--end" *ngIf="endLabel">
      {{ endLabel }}
    </span>
  </div>

  <div class="market-share-progress__scale" *ngIf="hasScaleStops">
    <span
      *ngFor="let stop of scaleStops"
      class="market-share-progress__scale-label"
      [class.market-share-progress__scale-label--start]="stop.edgeClass === 'start'"
      [class.market-share-progress__scale-label--end]="stop.edgeClass === 'end'"
      [ngStyle]="{ left: stop.left + '%' }"
    >
      {{ stop.label }}
    </span>
  </div>

  <div class="market-share-progress__footer">
    <strong *ngIf="!hideFooterValue">{{ valueLabel }}</strong>
    <span *ngIf="!hideFooterDescription">{{ description }}</span>
  </div>

  <div class="market-share-progress__divider" *ngIf="showDivider"></div>

  <div class="market-share-progress__details" *ngIf="details.length">
    <div *ngFor="let detail of details">{{ detail }}</div>
  </div>
</section>
